import { z } from 'zod';

import { jobSchema } from './job';
import {
    baseSkillSchema,
    extendedSkillSchema,
    hardSoftSkillProficiencyLevelSchema,
    languageSkillProficiencyLevelSchema,
} from './skill';

export const proficiencyLevelDetailSchema = z.object({
    description: z.string().optional(),
    descriptionShort: z.string().nullable().optional(),
    proficiencyLevel: hardSoftSkillProficiencyLevelSchema.or(languageSkillProficiencyLevelSchema),
});

export type ProficiencyLevelDetail = z.infer<typeof proficiencyLevelDetailSchema>;

export const skillDetailsSchema = extendedSkillSchema.extend({
    proficiencyLevelDetails: proficiencyLevelDetailSchema.array().optional(),
});

export type SkillDetails = z.infer<typeof skillDetailsSchema>;

export const relatedJobSchema = jobSchema.pick({ id: true, publishedAt: true, skills: true, title: true });
export type RelatedJob = z.infer<typeof relatedJobSchema>;

export const relatedSkillsSchema = baseSkillSchema.array();
export type RelatedSkills = z.infer<typeof relatedSkillsSchema>;

export type RelatedJobsOptions = {
    readonly page: number;
    readonly size: number;
};
